import { Check, Copy } from "lucide-react";
import { useState } from "react";

import { Button } from "@/design-system/Button";

/**
 * How a client makes the one key Skryptos accepts: contracts Read + Trade on a
 * Unified Trading Account, no Withdraw, and only this server's IP allowed.
 * Each step names the exact place in Bybit, so nobody has to guess.
 */
export function BybitKeyGuide({ requiredIp }: { requiredIp: string | null | undefined }): React.JSX.Element {
  const [copied, setCopied] = useState(false);
  return <ol className="flex list-decimal flex-col gap-2 pl-5" data-testid="bybit-key-guide">
    <li>Войдите в Bybit и откройте <b>Профиль → API → Создать новый ключ</b>, выберите <b>«Ключи API, сгенерированные системой»</b>.</li>
    <li>Назначение — <b>«Транзакция API»</b>, название — любое, например «Skryptos».</li>
    <li>Права — <b>«Чтение и запись»</b>. В разделе <b>«Единый торговый аккаунт»</b> отметьте <b>«Контракты: ордера и позиции»</b>.</li>
    <li><b>Не включайте «Вывод средств»</b> — Skryptos не принимает ключ с правом вывода.</li>
    <li>
      <span>Отметьте <b>«Доступ только с доверенных IP»</b> и впишите адрес Skryptos:</span>
      <span className="mt-1 flex flex-wrap items-center gap-2">
        <code className="rounded bg-background-base px-2 py-1 text-data-mono" data-testid="bybit-required-ip">{requiredIp ?? "адрес временно недоступен"}</code>
        {requiredIp != null && <Button
          type="button"
          variant="ghost"
          aria-label="Скопировать IP Skryptos"
          onClick={() => { void navigator.clipboard.writeText(requiredIp).then(() => { setCopied(true); }); }}
        >
          {copied ? <Check aria-hidden="true" className="size-4" /> : <Copy aria-hidden="true" className="size-4" />}
          {copied ? "Скопировано" : "Скопировать"}
        </Button>}
      </span>
    </li>
    <li>Подтвердите создание. Bybit покажет <b>API Key</b> и <b>Secret</b> один раз — вставьте их в поля ниже.</li>
  </ol>;
}
